var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmtMainLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3378_4599)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 45,
    r: 43,
    fill: "white",
    stroke: "#FD8238",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5873 55.288C28.3233 55.288 27.1473 55.056 26.0593 54.592C24.9873 54.128 24.0433 53.488 23.2273 52.672C22.4273 51.84 21.8033 50.864 21.3553 49.744C20.9073 48.624 20.6833 47.392 20.6833 46.048C20.6833 44.72 20.8993 43.496 21.3313 42.376C21.7793 41.24 22.4033 40.264 23.2033 39.448C24.0033 38.616 24.9393 37.976 26.0113 37.528C27.0833 37.064 28.2593 36.832 29.5393 36.832C30.8033 36.832 31.9313 37.048 32.9233 37.48C33.9313 37.912 34.7793 38.48 35.4673 39.184C36.1553 39.872 36.6513 40.624 36.9553 41.44L34.4353 42.664C34.0673 41.688 33.4593 40.904 32.6113 40.312C31.7633 39.704 30.7393 39.4 29.5393 39.4C28.3553 39.4 27.3073 39.68 26.3953 40.24C25.4833 40.8 24.7713 41.576 24.2593 42.568C23.7633 43.56 23.5153 44.72 23.5153 46.048C23.5153 47.376 23.7713 48.544 24.2833 49.552C24.8113 50.544 25.5313 51.32 26.4433 51.88C27.3553 52.424 28.4033 52.696 29.5873 52.696C30.5793 52.696 31.4833 52.496 32.2993 52.096C33.1313 51.68 33.7953 51.104 34.2913 50.368C34.7873 49.616 35.0353 48.744 35.0353 47.752V46.528L36.3073 47.68H29.5393V45.28H37.8433V46.96C37.8433 48.272 37.6193 49.448 37.1713 50.488C36.7233 51.512 36.1153 52.384 35.3473 53.104C34.5793 53.824 33.6993 54.368 32.7073 54.736C31.7153 55.104 30.6753 55.288 29.5873 55.288ZM40.7347 55V37.12H43.3747L50.0947 46.432H48.7747L55.3747 37.12H58.0147V55H55.2067V40.456L56.2627 40.744L49.5187 49.96H49.2307L42.6307 40.744L43.5667 40.456V55H40.7347ZM64.8793 55V39.64H60.1273V37.12H72.3673V39.64H67.6873V55H64.8793Z",
    fill: "#FD8238"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3378_4599",
    x: 0,
    y: 0,
    width: 92,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3378_4599"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3378_4599",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmtMainLogo);
export default __webpack_public_path__ + "static/media/gmt-main-logo.629c513d76aaa06339dbd3af9fe40c96.svg";
export { ForwardRef as ReactComponent };